import React, { Component, Fragment } from 'react';
import { Modal, Table } from 'react-bootstrap';
import config from '../../config';

class Example extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
  }
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  componentDidMount = () =>{
    fetch(config.servBackEnd + '/documents/current')
    .then (res1 => res1.json())
    .then((data1) => {
      ////console.log(data1.data)
      const noticias = data1.data;
      this.setState({
         noticias
      })
    })
    .catch((error) => console.error(error))
  }

  render() {
    const {item} = this.props;
    const {text} = this.props;
    const {cantidad} = this.props;
    const {costo} = this.props;
    const {fecha} = this.props;
    const {document} = this.props;
    const {des_bodega} = this.props;
    ////console.log(data);
    return (
      <Fragment>
        <p onClick={this.handleShow}>
          {text}
        </p>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>DETALLE DOCUEMTO</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Table striped bordered hover variant="dark">
  <thead>
    <tr>
    <th>FECHA</th>
      <th>DOCUMENTO</th>
      <th>BODEGA</th>
      <th>ITEM</th>
      <th>CANTIDADES</th>
      <th>COSTO</th>
    </tr>
  </thead>
  <tbody>
    <tr>
    <td>{fecha}</td>
    <td>{document}</td>
    <td>{des_bodega}</td>
      <td>{item}</td>
      <td>{cantidad}</td>
      <td>{costo}</td>
    </tr>
  </tbody>
</Table>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;


// WEBPACK FOOTER //
// ./src/components/subcomponent/modalDocument.jsx